import { render, staticRenderFns } from "./CoefficientOfVariation.vue?vue&type=template&id=6a9c2c4a&scoped=true&"
import script from "./CoefficientOfVariation.vue?vue&type=script&lang=js&"
export * from "./CoefficientOfVariation.vue?vue&type=script&lang=js&"
import style0 from "./CoefficientOfVariation.vue?vue&type=style&index=0&id=6a9c2c4a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a9c2c4a",
  null
  
)

export default component.exports